import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { ReservationsServices } from '../../services';
import { ReservationCalendarPage } from '../../reservation-calendar/reservation-calendar';
import { AnalyticsServices } from '../../../services/analyticsServices';


@Component({
    selector: 'page-reservation-config-horary',
    templateUrl: 'reservation-config-horary.html',
})
export class ReservationConfigHorary {
    firestore: any;
    schedules: any = [];
    start: any = "";
    end: any = "";
    monday: boolean = false;
    tuesday: boolean = false;
    wednesday: boolean = false;
    thursday: boolean = false;
    friday: boolean = false;
    saturday: boolean = false;
    sunday: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices,
        public afs: AngularFirestore,
        public translate: TranslateService,
        public toastCtrl: ToastController,
        public analyticsServices: AnalyticsServices) {
        this.firestore = firebase.firestore();
    }

    async ionViewWillEnter() {

    }

    addHorary() {
        //Comprovar que se hayan añadido las horas, y seleccionado minimo 1 dia
        if (this.start != "" && this.end != "" && (this.monday || this.tuesday || this.wednesday || this.thursday || this.friday || this.saturday || this.sunday)) {
            this.schedules.push({
                start: this.start,
                end: this.end,
                monday: this.monday,
                tuesday: this.tuesday,
                wednesday: this.wednesday,
                thursday: this.thursday,
                friday: this.friday,
                saturday: this.saturday,
                sunday: this.sunday
            });
            this.start = "";
            this.end = "";
            this.monday = false;
            this.tuesday = false;
            this.wednesday = false;
            this.thursday = false;
            this.friday = false;
            this.saturday = false;
            this.sunday = false;
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('reservas-error-horario'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    deleteHorary(index) {
        this.schedules.splice(index, 1);
    }

    next() {
        this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            form_online: true,
            horary: this.schedules
        });
        //create example emails
        this.reservationsServices.createReservationsExample();
        this.navCtrl.setRoot(ReservationCalendarPage, {
            plg_reservas_msg: true
        });
    }

    ionViewWillLeave() {
        this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            plg_reservas_finisher: true
        });
        this.globals.restaurant.plg_reservas_finisher = true;
        //send trackingExpReservations
        this.analyticsServices.trackingExpReservations('finisher', this.globals.tracking_exp['finisher']);
    }
}


// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-config/reservation-config-horary/reservation-config-horary.ts